import { ButtonOne } from "./Buttons";
import React from "react";
import { useState } from "react";

const SectionLabel = ({ data, style, invertColor }) => {
  const [section, setSection] = useState(data[0].text);
  //change button color according to click
  const sectionSelect = (value) => {
    return section === value
      ? { backgroundColor: "white", fontWeight: "700", fontSize: "16px", color: "#78D504" }
      : { backgroundColor: "transparent", fontWeight: "500", fontSize: "16px" };
  };

  return data.map(({ text }) => (
    <ButtonOne
      key={text}
      style={{
        ...styles.sectionButtons,
        color: invertColor ? "white" : "#78D504",
        ...sectionSelect(text),
        ...style,
      }}
      text={text}
      onClick={(e) => setSection(e.target.textContent)}
    />
  ));
};

const styles = {
  sectionButtons: {
    width: "20%",
  },
};

export default SectionLabel;
